import { TGeoLocationDto } from 'utility-tools/module/location'

import { TFiscalLocationDto } from './models'

const mapGeoLocationToFiscalLocation = (geoLocation: TGeoLocationDto): TFiscalLocationDto => {
    const { countryCode, countryName, regionIsoCode, regionName } = geoLocation

    return {
        country: {
            name: countryName,
            isoCode: countryCode,
        },
        state: {
            name: regionName,
            isoCode: regionIsoCode,
        },
    } as TFiscalLocationDto
}

export { mapGeoLocationToFiscalLocation }
